function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  width: 28,
  height: 28,
  rx: 4,
  fill: "#F2F6FA"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7 7l14 14M21 7L7 21",
  stroke: "#1063CD",
  strokeWidth: 2
});

const SvgClear = props => React.createElement("svg", _extends({
  width: 28,
  height: 28,
  fill: "none"
}, props), _ref, _ref2);

export default SvgClear;